export default __webpack_public_path__ + "static/media/outline_star_black_24dp 1.1c1ef821.svg";